import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';
import $ from 'jquery';


class ModuleReaSlider {

  constructor(){
    this.slider = jQuery(`[data-trigger='module-rea-slider']`);
    this.nav      = $("#js--module-layout-slider__nav");
    this.navItems = this.nav.find("li");
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){
        
        this.slider.owlCarousel({
          items:              1,
          nav:                false,
          navText:            ['',''],
          dots:               true,
          navContainerClass:  'owl-nav-realisations',
          onTranslated      : this.updateNav.bind(this),
          autoplay:           true,
          autoplayTimeout:    5000,
          autoplayHoverPause: true,
          autoHeight:         false,
        });

        this.owl = $(".owl-carousel").data('owlCarousel');

        let self = this;

        this.nav.on("click", "li", function(){
         this.currentIndex = $(this).index();
          $(this).addClass("js--active").siblings().removeClass("js--active");
          //this.owl.stop();
          //this.owl.to(currentIndex);
          self.slider.trigger( 'to.owl.carousel', [this.currentIndex] );
        });

      }  

    });
  }

	/**
	 * Change l'état actif de la navigation du carousel
	 * en fonction de l'index de la slide active
	 */
	updateNav(event){
		$(this.navItems).removeClass("js--active");
		$(this.navItems).eq(event.item.index).addClass("js--active");
	}

}

export const moduleReaSlider = new ModuleReaSlider();